function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormLabel, FormSelect } from '../../../style/export';
import PropertyLengthMeasure from '../../../../catalog/properties/property-lenght-measure';
import PropertyString from '../../../../catalog/properties/property-string';

export default function HoleAttributesEditor(_ref, _ref2) {
  var element = _ref.element,
      onUpdate = _ref.onUpdate,
      attributeFormData = _ref.attributeFormData,
      state = _ref.state,
      rest = _objectWithoutProperties(_ref, ['element', 'onUpdate', 'attributeFormData', 'state']);

  var translator = _ref2.translator;

  var name = attributeFormData.has('name') ? attributeFormData.get('name') : element.name;
  var offsetA = attributeFormData.has('offsetA') ? attributeFormData.get('offsetA') : element.offsetA;
  var offsetB = attributeFormData.has('offsetB') ? attributeFormData.get('offsetB') : element.offsetA;
  var scene = state.scene;
  var floors = scene.get('floors');
  var floorID = element.floorID ? element.floorID : floors.first().id;

  return React.createElement(
    'div',
    null,
    React.createElement(
      'div',
      { className: 'floor-record' },
      React.createElement(
        'div',
        { className: 'floor-label' },
        React.createElement(
          FormLabel,
          null,
          translator.t("Floor")
        )
      ),
      React.createElement(
        FormSelect,
        { value: floorID, onChange: function onChange(event) {
            return onUpdate('floorID', event.target.value);
          } },
        floors.toArray().map(function (floor, index) {
          return React.createElement(
            'option',
            { key: index, value: floor.id },
            floor.name
          );
        })
      )
    )
  );
}

HoleAttributesEditor.propTypes = {
  element: PropTypes.object.isRequired,
  onUpdate: PropTypes.func.isRequired,
  attributeFormData: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired
};

HoleAttributesEditor.contextTypes = {
  translator: PropTypes.object.isRequired
};